<div
  class="d-flex flex-row"
  [ngClass]="{
    'sequences-item--skipped': status() === StatementStatus.DECLINED,
    'sequences-item--sent': status() === StatementStatus.EXECUTED,
    'sequences-item--review': status() === StatementStatus.STAGED,
  }"
>
  <div class="status-icon col-1 d-flex justify-content-center align-items-center me-4">
    <ng-container [ngSwitch]="status()">
      <anduin-icon *ngSwitchCase="StatementStatus.EXECUTED" name="send" [fill]="'none'" [stroke]="'currentColor'" />
      <anduin-icon *ngSwitchCase="StatementStatus.DECLINED" name="skip-forward" [fill]="'none'" [stroke]="'currentColor'" />
      <anduin-icon *ngSwitchCase="StatementStatus.STAGED" name="clock" [fill]="'none'" [stroke]="'currentColor'" />
    </ng-container>
  </div>

  <mat-expansion-panel
    class="sequences-item flex-grow-1"
    [disabled]="status() === StatementStatus.DECLINED"
    (expandedChange)="$event && onStatementSelected()"
    hideToggle="true"
  >
    <mat-expansion-panel-header class="sequences-item__head p-4">
      <div class="d-flex justify-content-between w-100">
        <ng-container [ngSwitch]="status()">
          <div *ngSwitchCase="StatementStatus.DECLINED" class="d-flex flex-row align-items-center">
            <span> Statement skipped {{ (isCollectionsV2Enabled ? statement().statusUpdatedAt : _action.updated_at) | date }} </span>

            @if (firstInList && !excludedFromCollections) {
              @let shouldDisableUndoButton = !canEditAndSendStatements();
              <div
                [tooltipEnabled]="shouldDisableUndoButton"
                tooltip="You do not have permission to edit or send statements."
                class="ms-4"
              >
                <button
                  andButton
                  size="small"
                  color="secondary"
                  [isLoading]="isUndoProcessing()"
                  [disabled]="shouldDisableUndoButton"
                  (click)="handleUndoClick()"
                >
                  Undo
                </button>
              </div>
            }
          </div>

          <div *ngSwitchCase="StatementStatus.EXECUTED">
            Statement sent {{ (isCollectionsV2Enabled ? statement().statusUpdatedAt : _action.updated_at) | date }}
          </div>

          <ng-container *ngSwitchCase="StatementStatus.STAGED">
            <div>Next statement</div>
            <pill class="align-items-center" [dark]="true" color="red" size="small" value="REVIEW" />
          </ng-container>
        </ng-container>
      </div>
    </mat-expansion-panel-header>

    <!-- NOTE Using template to allow lazy loading the body (doesn't create until expanded) -->
    <ng-template class="item-body" matExpansionPanelContent>
      <!-- loading -->
      @if (isLoading()) {
        <mat-spinner class="mx-auto m-4" />
      }

      <!-- error -->
      <div *ngIf="didStatementPreviewError()" class="alert alert--error p-2 d-flex align-items-center justify-content-center">
        {{ previewErrorMessage() }}
      </div>

      <!-- Otherwise the statement preview will handle showing a spinner when making updates -->
      <statement-preview
        *ngIf="!isLoading() && !didStatementPreviewError()"
        [attachments]="attachments()"
        [canEditAndSendStatements]="canEditAndSendStatements()"
        [currentActionProcessing]="currentActionProcessing()"
        [edit]="status() === StatementStatus.STAGED"
        [emailAction]="emailMetadata().data"
        [noValidEmails]="noValidEmails()"
        [preview]="statementPreview().data"
        [previewLoading]="isStatementPreviewLoading()"
        (onApproveAction)="handleApprove($event)"
        (onAttachFile)="handleAttachment($event)"
        (onRemoveFile)="handleRemoveFile($event)"
        (onSendTestEmail)="handleTestEmail($event)"
        (onSkipStatement)="handleSkip()"
        (onUpdatePreview)="handleUpdatePreview($event)"
      />
    </ng-template>
  </mat-expansion-panel>
</div>
